export default {
  apiKey: "AIzaSyANNobhpDgk8e0LbjOLFmAMdji-O_MNE5A",
  authDomain: "skykick-2278.firebaseapp.com",
  databaseURL: "https://skykick-2278.firebaseio.com",
  projectId: "skykick-2278",
  storageBucket: "skykick-2278.appspot.com",
  messagingSenderId: "646317929822",
  appId: "1:646317929822:web:788bb6e1c62d6e78d98bcf",
};
